var jade = require("/home/romain/Cozy/cozy-proxy/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (figureid, id, link, t) {
buf.push("<div class=\"main-wrapper\"><header>");
if ( figureid)
{
buf.push("<figure" + (jade.attr("id", id, true, true)) + ">");
if ( link)
{
buf.push("<a" + (jade.attr("href", link, true, true)) + " target=\"_blank\"><svg><use" + (jade.attr("xlink:href", figureid, true, true)) + "></use></svg></a>");
}
else
{
buf.push("<div class=\"svg-wrapper\"><svg><use" + (jade.attr("xlink:href", figureid, true, true)) + "></use></svg></div>");
}
buf.push("</figure>");
}
buf.push("<h1>" + (jade.escape(null == (jade_interp = t('step confirmation title')) ? "" : jade_interp)) + "</h1></header><div role=\"region\"><p>" + (jade.escape(null == (jade_interp = t('step confirmation description line 1')) ? "" : jade_interp)) + "</p><p>" + (jade.escape(null == (jade_interp = t('step confirmation description line 2')) ? "" : jade_interp)) + "</p><p class=\"errors\"></p></div><footer><div class=\"controls\"><button class=\"next\">" + (jade.escape(null == (jade_interp = t('step confirmation next')) ? "" : jade_interp)) + "</button></div><div class=\"progression\"></div></footer></div>");}.call(this,"figureid" in locals_for_with?locals_for_with.figureid:typeof figureid!=="undefined"?figureid:undefined,"id" in locals_for_with?locals_for_with.id:typeof id!=="undefined"?id:undefined,"link" in locals_for_with?locals_for_with.link:typeof link!=="undefined"?link:undefined,"t" in locals_for_with?locals_for_with.t:typeof t!=="undefined"?t:undefined));;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/views/templates/view_steps_confirmation.jade
// module id = 22
// module chunks = 0